import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'

export const RESET_COMPARISON_SUCCESS = 'RESET_COMPARISON_SUCCESS'
export const onResetComparisonSuccess = makeActionCreator(RESET_COMPARISON_SUCCESS)

export const COMPARE_PROVIDERS = 'COMPARE_PROVIDERS'
export const COMPARE_PROVIDERS_ERROR = 'COMPARE_PROVIDERS_ERROR'
export const COMPARE_PROVIDERS_SUCCESS = 'COMPARE_PROVIDERS_SUCCESS'
export const onCompareProviders = makeActionCreator(COMPARE_PROVIDERS)
export const onCompareProvidersError = makeActionCreator(COMPARE_PROVIDERS_ERROR, 'payload')
export const onCompareProvidersSuccess = makeActionCreator(COMPARE_PROVIDERS_SUCCESS, 'payload')
export const onCompareProvidersThunk = payload => async dispatch => {
  dispatch(onCompareProviders())

  try {
    return batch(() => {
      dispatch(onCompareProvidersSuccess(payload))
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onCompareProvidersError(error))
  }
}
